export function slugify(value = "") {
  return String(value)
    .replace(/ä/g, "ae")
    .replace(/Ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/Ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/Ü/g, "ue")
    .replace(/ß/g, "ss")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 90);
}

export function vehicleSlug(vehicle = {}) {
  return slugify([
    vehicle.brand,
    vehicle.model,
    vehicle.title,
    vehicle.year,
  ].filter(Boolean).join(" ")) || "fahrzeug";
}

export function vehicleUrl(vehicle = {}) {
  return `/fahrzeuge/${vehicle.slug || vehicleSlug(vehicle)}`;
}
